import generateMutation from '../../../graphql/mutations/product/ProductLabelGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/product/ProductLabelGenerateRangeMutation.graphql';

import hasValidationErrors from '../../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob, IJobMeta } from '../../../utils/BackgroundJobs';
import { onDocumentPrintComplete, onDocumentPrintFailed } from '../../../utils/DocumentUtils';
import { getMutationProps } from '../../../actions/sales/DocumentAction';
import { EntityType, IGenerateRangeFunction, IGenerateSingleFunction } from '../../../@types/entityTypes';

import { ReportType } from '../../../graphql/schema/p4types';

export const generate: IGenerateSingleFunction = (state, props, variables, returnUrl) => {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    generateMutation,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Product Labels',
    (job) => onDocumentPrintComplete(state, props, job)
  );
};

export const generateRange: IGenerateRangeFunction = (state, props, variables, returnUrl, { rangeMutationProps }) => {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    generateRangeMutation,
    rangeMutationProps,
    props,
    returnUrl,
    'Generate Product Labels',
    (job) => onDocumentPrintComplete(state, props, job),
    (job?: IJobMeta) => onDocumentPrintFailed(state, props, job)
  );
};

const ProductLabel: EntityType = {
  type: 'ProductLabel',
  title: 'Product Label (Sales Orders)',
  formTitle: 'Print Product Labels (Sales Order Lines)',
  printFunctions: {
    generate,
    generateRange,
  },
  actions: [],
  configuration: {
    title: 'Product Label (Sales Order Lines)',
    reportType: ReportType.ProductLabel,
    field: 'productLabelDefault',
  },
  screenReference: 'SALES_ORDER_PRODUCT_LABEL',
};

export default ProductLabel;
